import react, { useEffect, useRef, useState } from "react";
import analytics from "../analytics/analytics.js";
import { browserStorageManager } from "../utils/browserStorage.js";
import { transformSessionResponse } from "../utils/sessionUtils.js";
import UseRefreshSessionAccess from "./UseRefreshSessionAccess.js";
const usePromptRetrieval = (args)=>{
    const [statusMsg, setStatusMesg] = useState('');
    const { cguid, chatMessages, isSessionActive, limit = 5, productId = 0, requestFrom = '', retrieveUrl, setChatMessages, setLastPromptId, setRetrievalLoading, triggerOnLoad, retrievalLoading } = args;
    UseRefreshSessionAccess();
    const chatMessagesRef = useRef(chatMessages);
    useEffect(()=>{
        chatMessagesRef.current = chatMessages;
    }, [
        chatMessages
    ]);
    const retrievalLoadingRef = useRef(retrievalLoading);
    useEffect(()=>{
        retrievalLoadingRef.current = retrievalLoading;
    }, [
        retrievalLoading
    ]);
    const retrievePrompts = react.useCallback(()=>{
        if (!isSessionActive || 'undefined' == typeof window || retrievalLoadingRef.current) return void setStatusMesg('Failed');
        const storageCount = browserStorageManager.getBrowserStorage()?.getUserMessageCount() || 0;
        const stateCount = chatMessagesRef.current?.filter((message)=>message?.role === 'user' && message?.content !== '').length || 0;
        const shouldFetch = storageCount !== stateCount || chatMessagesRef?.current?.length === 0;
        if (shouldFetch) {
            setRetrievalLoading(true);
            const abortController = new AbortController();
            setTimeout(()=>{
                abortController.abort();
            }, 30000);
            const fetchMe = async ()=>{
                const pennysid = browserStorageManager.getBrowserStorage()?.getItem('pennysid') ?? '';
                return await fetch(retrieveUrl, {
                    method: 'POST',
                    signal: abortController.signal,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        pennysid,
                        cguid,
                        limit,
                        isSessionActive,
                        productId,
                        requestFrom
                    })
                });
            };
            fetchMe().then(async (result)=>{
                const sessionResult = await result?.json();
                if (sessionResult?.token) sessionStorage.setItem('pennysid', sessionResult.token);
                else analytics.log({
                    source: 'usePromptRetrieval',
                    message: `Invalid token sent, token is ${sessionResult?.token}`
                });
                const sessionData = sessionResult.data;
                if (sessionData?.length) {
                    const sessionChatMessage = sessionData.map((item)=>transformSessionResponse(item));
                    setLastPromptId(sessionData[0]?.promptId);
                    setChatMessages(sessionChatMessage);
                    setStatusMesg('Success');
                }
            }).catch((e)=>{
                setStatusMesg('Failed');
                analytics.log({
                    source: 'Chatbot retrieve error',
                    message: e.message
                });
            }).finally(()=>setRetrievalLoading(false));
        }
    }, [
        isSessionActive,
        cguid,
        limit,
        productId,
        requestFrom,
        retrieveUrl,
        setChatMessages,
        setLastPromptId,
        setRetrievalLoading,
        setStatusMesg
    ]);
    useEffect(()=>{
        if (triggerOnLoad) retrievePrompts();
    }, [
        triggerOnLoad,
        retrievePrompts
    ]);
    useEffect(()=>{
        const handleVisibilityChange = ()=>{
            if ('visible' === document.visibilityState) retrievePrompts();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        retrievePrompts
    ]);
    return {
        statusMsg,
        retrievePrompts
    };
};
const hooks_usePromptRetrieval = usePromptRetrieval;
export { hooks_usePromptRetrieval as default };
